import { Routes, Route } from 'react-router-dom';
import { AnimatedPage } from '@theonefamily/ui';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { Layout } from '@/components/Layout';
import { DashboardPage } from '@/pages/DashboardPage';
import { EmployeesPage } from '@/pages/EmployeesPage';
import { EmployeeDetailPage } from '@/pages/EmployeeDetailPage';
import { EmployeeCreatePage } from '@/pages/EmployeeCreatePage';
import { CandidatesPage } from '@/pages/CandidatesPage';
import { CandidateDetailPage } from '@/pages/CandidateDetailPage';
import { CandidateCreatePage } from '@/pages/CandidateCreatePage';
import { JobsPage } from '@/pages/JobsPage';
import { JobDetailPage } from '@/pages/JobDetailPage';
import { JobCreatePage } from '@/pages/JobCreatePage';
import { ReviewDetailPage } from '@/pages/ReviewDetailPage';
import { InterviewsPage } from '@/pages/InterviewsPage';
import { TimeOffPage } from '@/pages/TimeOffPage';
import { ReviewsPage } from '@/pages/ReviewsPage';
import { TrainingPage } from '@/pages/TrainingPage';
import { OnboardingPage } from '@/pages/OnboardingPage';
import { OffboardingPage } from '@/pages/OffboardingPage';
import { OrgChartPage } from '@/pages/OrgChartPage';
import { WorkDNAPage } from '@/pages/WorkDNAPage';
import { CompensationPage } from '@/pages/CompensationPage';
import { ReportsPage } from '@/pages/ReportsPage';
import { ESignPage } from '@/pages/ESignPage';
import { AdminPage } from '@/pages/AdminPage';
import { PTOPoliciesAdminPage } from '@/pages/admin/PTOPoliciesAdminPage';
import { DepartmentsAdminPage } from '@/pages/admin/DepartmentsAdminPage';
import { OnboardingTemplatesAdminPage } from '@/pages/admin/OnboardingTemplatesAdminPage';
import { ReviewCyclesAdminPage } from '@/pages/admin/ReviewCyclesAdminPage';
import { SalaryBandsAdminPage } from '@/pages/admin/SalaryBandsAdminPage';
import { IntegrationsAdminPage } from '@/pages/admin/IntegrationsAdminPage';
import { PoliciesPage } from '@/pages/PoliciesPage';
import { PolicySignPage } from '@/pages/PolicySignPage';
import { EmployeePIIPage } from '@/pages/EmployeePIIPage';
import { BackgroundCheckPage } from '@/pages/BackgroundCheckPage';
import { TheoHRPage } from '@/pages/TheoHRPage';
import { SkillsMatrixPage } from '@/pages/SkillsMatrixPage';
import { PulseSurveysPage } from '@/pages/PulseSurveysPage';
import { CompensationIntelligencePage } from '@/pages/CompensationIntelligencePage';
import { AttritionModelPage } from '@/pages/AttritionModelPage';
import { PeerFeedbackPage } from '@/pages/PeerFeedbackPage';
import { ShiftIntelligencePage } from '@/pages/ShiftIntelligencePage';
import { CareerPathPage } from '@/pages/CareerPathPage';
import { TeamChemistryPage } from '@/pages/TeamChemistryPage';
import { IVerifyPage } from '@/pages/IVerifyPage';
import { GlobalWorkforcePage } from '@/pages/GlobalWorkforcePage';
import { SuccessionPlanningPage } from '@/pages/SuccessionPlanningPage';
import { EngagementScorePage } from '@/pages/EngagementScorePage';
import { JobDescriptionGeneratorPage } from '@/pages/JobDescriptionGeneratorPage';
import { CandidateSourcingPage } from '@/pages/CandidateSourcingPage';
import { BenefitsPage } from '@/pages/BenefitsPage';
import { HrisApiPage } from '@/pages/admin/HrisApiPage';
import { AccessAdminPage } from '@/pages/admin/AccessAdminPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function App() {
  return (
    <ErrorBoundary>
      <AnimatedPage>
        <Routes>
          <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="employees/new" element={<EmployeeCreatePage />} />
        <Route path="employees/:id" element={<EmployeeDetailPage />} />
        <Route path="employees/:id/sensitive-info" element={<EmployeePIIPage />} />
        <Route path="candidates" element={<CandidatesPage />} />
        <Route path="candidates/new" element={<CandidateCreatePage />} />
        <Route path="candidates/:id" element={<CandidateDetailPage />} />
        <Route path="jobs" element={<JobsPage />} />
        <Route path="jobs/new" element={<JobCreatePage />} />
        <Route path="jobs/:id" element={<JobDetailPage />} />
        <Route path="interviews" element={<InterviewsPage />} />
        <Route path="time-off" element={<TimeOffPage />} />
        <Route path="reviews" element={<ReviewsPage />} />
        <Route path="reviews/:id" element={<ReviewDetailPage />} />
        <Route path="training" element={<TrainingPage />} />
        <Route path="onboarding" element={<OnboardingPage />} />
        <Route path="offboarding" element={<OffboardingPage />} />
        <Route path="org-chart" element={<OrgChartPage />} />
        <Route path="workdna" element={<WorkDNAPage />} />
        <Route path="compensation" element={<CompensationPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="esign" element={<ESignPage />} />
        <Route path="policies" element={<PoliciesPage />} />
        <Route path="policies/:id/sign" element={<PolicySignPage />} />
        <Route path="hr/background-checks" element={<BackgroundCheckPage />} />
        <Route path="theo-hr" element={<TheoHRPage />} />
        <Route path="skills-matrix" element={<SkillsMatrixPage />} />
        <Route path="pulse-surveys" element={<PulseSurveysPage />} />
        <Route path="compensation-intelligence" element={<CompensationIntelligencePage />} />
        <Route path="attrition-model" element={<AttritionModelPage />} />
        <Route path="peer-feedback" element={<PeerFeedbackPage />} />
        <Route path="shift-intelligence" element={<ShiftIntelligencePage />} />
        <Route path="career-paths" element={<CareerPathPage />} />
        <Route path="team-chemistry" element={<TeamChemistryPage />} />
        <Route path="i9-everify" element={<IVerifyPage />} />
        <Route path="global-workforce" element={<GlobalWorkforcePage />} />
        <Route path="succession-planning" element={<SuccessionPlanningPage />} />
        <Route path="engagement" element={<EngagementScorePage />} />
        <Route path="job-description-generator" element={<JobDescriptionGeneratorPage />} />
        <Route path="candidate-sourcing" element={<CandidateSourcingPage />} />
        <Route path="benefits" element={<BenefitsPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="admin/pto-policies" element={<PTOPoliciesAdminPage />} />
        <Route path="admin/departments" element={<DepartmentsAdminPage />} />
        <Route path="admin/onboarding-templates" element={<OnboardingTemplatesAdminPage />} />
        <Route path="admin/review-cycles" element={<ReviewCyclesAdminPage />} />
        <Route path="admin/salary-bands" element={<SalaryBandsAdminPage />} />
        <Route path="admin/integrations" element={<IntegrationsAdminPage />} />
        <Route path="admin/hris-api" element={<HrisApiPage />} />
        <Route path="admin/access" element={<AccessAdminPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
        </Routes>
      </AnimatedPage>
    </ErrorBoundary>
  );
}
